import {TooltipState} from './tooltip-state';
import { distinctUntilChanged } from 'rxjs/operators';
class TooltipApi{
	constructor(state = new TooltipState()){
		this._state = state;
	}
	init(){
        this.state.pipe(distinctUntilChanged(null, state=>{
            return state.isTooltipVisible;
        })).subscribe( (state )=>{
            if(state.isTooltipVisible){
                this.state.isWidgetActive = true;
            }
            else{
                this.state.isWidgetActive = false;
            }
        })
	}
	get state(){
		return this._state;
	}
	set state(state){
		this._state = state;
	}
	disableLayer(){
		this.state.isLayerEnabled = false;
	}
	enableLayer(){
		this.state.isLayerEnabled = true;
	}
	setMouseOverWidget(flag=this.state.isMouseOverWidget){
		this.state.isMouseOverWidget = flag;
	}
	setMouseOverTooltip(flag=this.state.isMouseOverTooltip){
		this.state.isMouseOverTooltip = flag;
	}
	hideTooltip(allow=false){
		if(allow==true){
			this.state.isTooltipVisible=false;
		}
		else if(!this.state.isMouseOverTooltip && !this.state.isMouseOverWidget){
			this.state.isTooltipVisible=false;
		}
	}
	showTooltip(allow=false){

		if(allow==true){
			this.state.isTooltipVisible=true;
		}
		else if((this.state.isWidgetActive && this.state.isMouseOverTooltip) || this.state.isMouseOverWidget){
			this.state.isTooltipVisible=true;
		}
	}

}

export {TooltipApi}